import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { TariffOutput } from "~@/graphql/codegen/generated";

interface PricingState {
  selectedTariff: TariffOutput | null;
}

const initialState: PricingState = {
  selectedTariff: null,
};

const pricingSlice = createSlice({
  name: "pricing",
  initialState,
  reducers: {
    selectTariff(state, action: PayloadAction<TariffOutput | null>) {
      state.selectedTariff = action.payload;
    },
    clearSelectedTariff(state) {
      state.selectedTariff = null;
    },
  },
});

export const { selectTariff, clearSelectedTariff } = pricingSlice.actions;
export default pricingSlice.reducer;
